// extracted by mini-css-extract-plugin
export default {"dynamic-delete-button":"modal_menu_dynamic-delete-button__SBDgQ"};